import './ViewLabel.scss';
import { DeleteViewButton } from './DeleteViewButton';
import { EditFilled } from '@ant-design/icons';
import React from 'react';
import { RenameView } from './RenameView';
import { ShareViewButton } from './ShareViewButton';
import { Space } from 'antd';
import { UpdateViewButton } from './UpdateViewButton';
import { ViewQueryParams } from './CreateView';
import { DataDictionaryView, FeatureFlag } from '@sonar-software/sonar-core';
import { useBoolean, useCurrentUser, useFeatureFlag } from '@hooks';

export interface ViewLabelProps {
	queryParams: ViewQueryParams;
	view: DataDictionaryView;
}

export const ViewLabel: React.FC<ViewLabelProps> = ({ queryParams, view }) => {
	const canShare = useFeatureFlag(FeatureFlag.EmbeddedDataDictionary);
	const [ isEditing, setIsEditing ] = useBoolean(false);
	const { isReadOnly } = useCurrentUser();

	if (isEditing) {
		return <RenameView
			onCancel={ setIsEditing.off }
			onFinish={ setIsEditing.off }
			view={ view } />;
	}

	const { id, name } = view;

	return (
		<Space className='view-label'>
			{ !isReadOnly && <UpdateViewButton
				queryParams={ queryParams }
				view={ view } /> }
			<span>{ name }</span>
			{ !isReadOnly &&
				<>
					{ canShare &&
						<ShareViewButton
							className='view-label-action'
							existingSharedKey={ view.sharedKey }
							viewId={ id } /> }
					<EditFilled
						className='view-label-action view-label-edit'
						onClick={ (e) => {
							e.stopPropagation();
							setIsEditing.on();
						} } />
					<DeleteViewButton
						className='view-label-action'
						viewId={ id } />
				</> }
		</Space>
	);
};
